import type { Blueprint } from '../blueprint/blueprint.class';
import { BlueprintContext } from '../blueprint-context/blueprint-context.class';
import { BlueprintInstanceType } from '../public.enums';
import { BlueprintOptions } from './types';
import { ControllerRootBase, EventPayloadCrud } from '../../controller-classes';

export class BlueprintBase<
	SerializedDataType
> extends ControllerRootBase<
	SerializedDataType,
	BlueprintContext
> {
	constructor (instanceOf: BlueprintInstanceType, options: BlueprintOptions<SerializedDataType> = {}, context: BlueprintContext | null = null) {
		super(instanceOf, options, context)

		if (instanceOf === BlueprintInstanceType.Blueprint) {
			// eslint-disable-next-line dot-notation
			this._context = new BlueprintContext({
				userEmail: options.userEmail ?? 'SYSTEM',
				priceBook: options.priceBook ?? null,
				blueprint: this as any
			});
		} else if (context === null) {
			this._context = new BlueprintContext({ userEmail: 'UNKNOWN' });
		} else {
			this._context = context;
		}
	}

	public cleanup (): void {
		// console.log(`cleanup (base:${this.instanceOf})`, this.id);
		const payload: EventPayloadCrud = {
			ref: this.id,
			old: this.serialize(),
			new: null
		};
		this.publish(this.instanceOf, 'deleted', payload);
	}
}
